module.exports = __webpack_public_path__ + "static/banner-four-shape3-3f955d1885889144480f96258a938d39.png";